import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4h-5.17L15 2H9L7.17 4H2v16h20V4zm-7 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
}), 'SwitchCameraSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwitchCameraSharp.js
// module id = 6626
// module chunks = 2